const STYLES = {
  "Aguardando pagamento": "bg-amber-100 text-amber-800 border-amber-200",
  Pago: "bg-blue-100 text-blue-800 border-blue-200",
  "Em produção": "bg-pink-100 text-pink-800 border-pink-200",
  Concluído: "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Disponível para retirada": "bg-green-100 text-green-800 border-green-200",
};

export function StatusBadge({ status, testId = "order-status-badge" }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold ${STYLES[status] || "bg-slate-100 text-slate-700"}`}>
      {status}
    </span>
  );
}
